export type MainboardFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type MainboardFilterGroup = {
  id: string;
  label: string;
  options: MainboardFilterOption[];
};

export const mainboardFilterGroups: MainboardFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'asrock', label: 'ASROCK', keywords: ['asrock'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus'] },
      { value: 'biostar', label: 'BIOSTAR', keywords: ['biostar'] },
      { value: 'colorful', label: 'COLORFUL', keywords: ['colorful'] },
      { value: 'gigabyte', label: 'GIGABYTE', keywords: ['gigabyte', 'aorus'] },
      { value: 'huananzhi', label: 'HUANANZHI', keywords: ['huananzhi'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'onda', label: 'ONDA', keywords: ['onda'] },
      { value: 'sapphire', label: 'SAPPHIRE', keywords: ['sapphire'] },
      { value: 'sstc', label: 'SSTC', keywords: ['sstc'] },
      { value: 't-wolf', label: 'T-WOLF', keywords: ['t-wolf', 'twolf'] },
      { value: 'unika', label: 'UNIKA', keywords: ['unika'] },
      { value: 'vsp', label: 'VSP', keywords: ['vsp'] },
    ],
  },
  {
    id: 'platform',
    label: 'Nền tảng',
    options: [
      { value: 'intel', label: 'Intel', keywords: ['intel'] },
      { value: 'amd', label: 'AMD', keywords: ['amd'] },
    ],
  },
  {
    id: 'socket',
    label: 'Socket',
    options: [
      { value: 'lga1200', label: 'LGA 1200', keywords: ['lga 1200', 'lga1200'] },
      { value: 'lga1700', label: 'LGA 1700', keywords: ['lga 1700', 'lga1700'] },
      { value: 'lga1851', label: 'LGA 1851', keywords: ['lga 1851', 'lga1851'] },
      { value: 'lga2011', label: 'LGA 2011', keywords: ['lga 2011', 'lga2011'] },
      { value: 'lga2066', label: 'LGA 2066', keywords: ['lga 2066', 'lga2066'] },
      { value: 'am4', label: 'AM4', keywords: ['am4'] },
      { value: 'am5', label: 'AM5', keywords: ['am5'] },
    ],
  },
  {
    id: 'chipset',
    label: 'Chipset',
    options: [
      { value: 'a520', label: 'A520', keywords: ['a520'] },
      { value: 'a620', label: 'A620', keywords: ['a620'] },
      { value: 'b450', label: 'B450', keywords: ['b450'] },
      { value: 'b550', label: 'B550', keywords: ['b550'] },
      { value: 'b650', label: 'B650', keywords: ['b650'] },
      { value: 'x570', label: 'X570', keywords: ['x570'] },
      { value: 'x670', label: 'X670', keywords: ['x670'] },
      { value: 'h610', label: 'H610', keywords: ['h610'] },
      { value: 'b660', label: 'B660', keywords: ['b660'] },
      { value: 'b760', label: 'B760', keywords: ['b760'] },
      { value: 'z690', label: 'Z690', keywords: ['z690'] },
      { value: 'z790', label: 'Z790', keywords: ['z790'] },
    ],
  },
  {
    id: 'ram-generation',
    label: 'Thế hệ RAM',
    options: [
      { value: 'ddr3', label: 'DDR3', keywords: ['ddr3'] },
      { value: 'ddr4', label: 'DDR4', keywords: ['ddr4'] },
      { value: 'ddr5', label: 'DDR5', keywords: ['ddr5'] },
    ],
  },
  {
    id: 'ram-slots',
    label: 'Số khe RAM',
    options: [
      { value: 'ram2', label: 'RAM_2 khe', keywords: ['2 khe ram', '2 dimm', 'ram_2 khe'] },
      { value: 'ram4', label: 'RAM_4 khe', keywords: ['4 khe ram', '4 dimm', 'ram_4 khe'] },
      { value: 'ram8', label: 'RAM_8 khe', keywords: ['8 khe ram', '8 dimm', 'ram_8 khe'] },
    ],
  },
  {
    id: 'form-factor',
    label: 'Form Factor',
    options: [
      { value: 'mini-itx', label: 'Mini ITX', keywords: ['mini itx', 'mini-itx'] },
      { value: 'matx', label: 'mATX', keywords: ['matx', 'micro atx'] },
      { value: 'atx', label: 'ATX (Standard)', keywords: ['atx', 'atx standard'] },
      { value: 'eatx', label: 'EATX', keywords: ['eatx', 'e-atx'] },
    ],
  },
];
